/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Question_PronunciationInputs */

const en_faq_question_pronunciation = /** @type {(inputs: Faq_Question_PronunciationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can it pronounce difficult words, like "Mesothelioma" or "Diphenhydramine"?`)
};

const es_faq_question_pronunciation = /** @type {(inputs: Faq_Question_PronunciationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puede pronunciar palabras difíciles, como "Mesothelioma" o "Diphenhydramine"?`)
};

/**
* | output |
* | --- |
* | "Can it pronounce difficult words, like \"Mesothelioma\" or \"Diphenhydramine\"?" |
*
* @param {Faq_Question_PronunciationInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const faq_question_pronunciation = /** @type {((inputs?: Faq_Question_PronunciationInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Question_PronunciationInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_faq_question_pronunciation(inputs)
	return en_faq_question_pronunciation(inputs)
});